
const elementInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  const rightSideXCoordinate = rect.x + rect.width;

  return (
    rightSideXCoordinate <= window.innerWidth
  );
}


export default class ImageCarousel {
  constructor() {
    this.selector = '.b-gallery';
    this.sliders = [];
  }

  // eslint-disable-next-line class-methods-use-this
  bootstrap() {
    const blocks = document.querySelectorAll(this.selector);
    blocks.forEach(block => {
      const slider = block.querySelector('.b-gallery__slider');
      Promise.all(Array.from(slider.querySelectorAll('img')).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
        this.initFlickity(slider);
      });
    });

    window.addEventListener('resize', () => {
      blocks.forEach(block => {
        const slider = block.querySelector('.b-gallery__slider');
        this.initFlickity(slider);
      });
    });
  }

  destroySliders() {
    return new Promise((resolve) => {
      this.sliders.forEach(item => {
        item.destroy();
        this.sliders.pop(item);
      });

      resolve();
    });
  }

  initFlickity(slider) {
    const slides = slider.querySelectorAll('.slide');

    $( slides ).matchHeight({
      byRow: false
    });

    // we need to destroy all sliders if any already inited
    this.destroySliders().then(() => {
      slider.parentNode.classList.add('no-slide');
      let anySlideOutOfView = false;

      // position slider
      const sliderWrap = slider.parentNode.parentNode;
      const container = document.querySelector('.b-gallery__container');

      if ( window.innerWidth > 767 ) {
        const containerWidth = parseFloat(getComputedStyle(container, null).width.replace("px", ""));
        const containerPadding = parseFloat(getComputedStyle(container, null).paddingLeft.replace("px", ""));
        const paddingToAdd = ((window.innerWidth - containerWidth ) / 2) + containerPadding;
        sliderWrap.style.paddingLeft = `${paddingToAdd}px`;
      } else {
        sliderWrap.style.paddingLeft = null;
      }

      slides.forEach( slide => {
        if (!elementInViewport(slide)) {
          anySlideOutOfView = true;
        }
      });

      if ( anySlideOutOfView ) {
        slider.parentNode.classList.remove('no-slide');

        const flkty = new Flickity(slider, {
          wrapAround: true,
          cellAlign: 'left',
          pageDots: false,
          prevNextButtons: false
        });

        this.sliders.push(flkty);

        // add button handlers
        const btnPrev = slider.parentNode.querySelector('.prev');
        const btnNext = slider.parentNode.querySelector('.next');

        btnPrev.addEventListener('click', event => {
          event.preventDefault();
          flkty.previous( true, false );
        });

        btnNext.addEventListener('click', event => {
          event.preventDefault();
          flkty.next( true, false );
        });
      }

    });
  }
}
